import { Component, Injector, Input } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { FormControl, FormArray, Validators } from '@angular/forms';
import { getParameterTypeErrorMessage, parameterValueTypeValidator } from '../../../validators/parameter-type.validator';

@Component({
  selector: 'app-parameter-values-modal',
  templateUrl: './parameter-values-modal.component.html',
  styleUrls: ['./parameter-values-modal.component.scss'],
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ParameterValuesModalComponent extends BaseModalComponent<any> {
  @Input() canEdit = false;
  @Input() stepValues: FormArray<FormControl> = new FormArray([new FormControl('')]);
  @Input() parameterType = 0;

  constructor(injector: Injector) {
    super(injector);
  }

  getParameterTypeErrorMessage = getParameterTypeErrorMessage;

  addValue(): void {
    this.stepValues.push(new FormControl('', [Validators.required, parameterValueTypeValidator(this.parameterType)]));
  }

  onClose(): void {
    this.close({ action: 'close', data: null });
  }

  removeValue(index: number) {
    this.stepValues.removeAt(index);
  }

  onSave(): void {
    if (this.stepValues.valid) {
      this.close({ action: 'save', data: this.stepValues });
    }
  }
}
